import { render, staticRenderFns } from "./modelover.vue?vue&type=template&id=c967c426&scoped=true&"
import script from "./modelover.vue?vue&type=script&lang=js&"
export * from "./modelover.vue?vue&type=script&lang=js&"
import style0 from "./modelover.vue?vue&type=style&index=0&id=c967c426&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c967c426",
  null
  
)

export default component.exports